import { ContractType } from '../../user/types'

export enum RegistrationType {
  Full = 'Full',
  Light = 'Light'
}

export enum ContractStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum UserType {
  Company = 'Company',
  Private = 'Private'
}

export type AccountingDataBillingAddress = {
  address?: string
  city?: string
  zipCode?: string
  province?: string
  provinceCode?: string
  country?: string
  countryCode?: string
  billingEmailAddress?: string
}

export type ReportPackage = {
  id: string
  reportCode: string
  totalReports?: string | number
  consumedReports?: string | number
}

export type Contract = {
  type?: ContractType
  status?: ContractStatus
  prepaidBalanceNet?: string
  displayPrepaidBalanceNet?: string
  prepaidBalanceTaxes?: string
  displayPrepaidBalanceTaxes?: string
  prepaidBalanceGross?: string
  displayPrepaidBalanceGross?: string
  currency?: string
  validTo?: string
  reportPackages?: ReportPackage[]
  isTrialSubscription?: boolean
}

export type AccountingData = {
  billingAddress: AccountingDataBillingAddress
  invoicing?: {
    recipientCode?: string
  }
  registrationType: RegistrationType
  taxId?: string
  contracts?: Contract[]
}

export type UserProfileData = {
  crifAccount: {
    givenName: string
    familyName: string
    companyName: string
    email: string
    phone?: string
    languageCode: string
    userType: UserType
    contactAuthorization: {
      newsletter: boolean
      communications: boolean
      messages: boolean
    }
    policiesAcceptance?: {
      name: string
      value?: string
    }[]
    office?: {
      name: string
      officeId: string
    }
  }
  accounting: AccountingData
}

export type AccountUserState = {
  data: UserProfileData
}
